import type { deTelephony } from './de.telephony';

export const enTelephony: Record<keyof typeof deTelephony, string> = {
  'campaign.tab.phone': 'Calling',

  'call.title': 'Call',
  'call.manualNumber': 'Phone number',
  'call.start': 'Call',
  'call.hangup': 'Hang up',
  'call.mute': 'Mute',
  'call.unmute': 'Unmute',
  'call.continue': 'Continue calling',
  'call.wrapUp': 'Record the result',
  'call.state.idle': 'Ready',
  'call.state.dialing': 'Connecting …',
  'call.state.ringing': 'Ringing …',
  'call.state.connected': 'On call',
  'call.state.reconnecting': 'Connection interrupted – please wait',
  'call.state.ended': 'Call ended',
  'call.phoneUnavailable': 'Calling is not available right now. Please try again in a moment.',
  'call.providerProblem': 'There is a problem with the telephony provider. Please contact your administrator.',
  'call.reconnected': 'The connection is back.',

  'sip.title': 'Telephony provider',
  'sip.hint': 'You get these details from your telephony provider.',
  'sip.host': 'Server',
  'sip.username': 'User name',
  'sip.password': 'Password',
  'sip.passwordStored': 'Password saved',
  'sip.passwordKeep': 'Leave empty to keep the saved password.',
  'sip.port': 'Port',
  'sip.transport': 'Transport',
  'sip.authId': 'Login name',
  'sip.realm': 'Domain',
  'sip.mode': 'Access type',
  'sip.mode.global': 'One access for the whole team',
  'sip.mode.individual': 'Own access per caller',
  'sip.test': 'Test connection',
  'sip.test.ok': 'Connection to the telephony provider succeeded.',
  'sip.test.rejected': 'The telephony provider rejected the login. Please check user name and password.',
  'sip.test.unreachable': 'The telephony provider cannot be reached.',
  'sip.notConfigured': 'No telephony provider has been set up for this campaign yet.',
  'sip.forUser': 'Access for',

  'error.sip.not_configured': 'No telephony provider has been set up for this campaign yet.',
  'error.sip.not_configured_for_user': 'No telephony provider has been set up for you in this campaign.',
  'error.sip.wrong_mode': 'This access type does not match the campaign setting.',
  'error.sip.password_required': 'Please enter the password of the telephony provider.',
  'error.sip.incomplete': 'Please enter server and user name.',
  'error.call.not_found': 'This call was not found.',
  'error.call.not_ended': 'The call is still running.',
  'error.call.already_active': 'You are already on a call.',
  'error.call.sales_result_required': 'Please record the result of the call.',
  'error.call.required_fields_missing': 'Please fill in the marked fields.',
  'error.campaign.stopped': 'This campaign is stopped. Please contact your administrator.',
  'error.campaign.calls_in_progress':
    'Calls are in progress in this campaign. Please wait until they have ended.',
  'error.billing.insufficient_balance': 'Your credit is not enough for another call. Please top up.',
  'error.telephony.unavailable': 'Calling is not available right now. Please try again in a moment.',
  'error.telephony.failed': 'The call could not be set up.',
  'call.microphoneDenied':
    'The browser denied access to your microphone. Please allow it for this page and reload.',
  'call.microphoneMissing':
    'No microphone is connected. Please plug in a headset and reload the page.',
  'call.microphoneBusy':
    'Another program is currently using the microphone. Please close it and reload the page.',
  'call.microphoneUnavailable':
    'This browser cannot give access to the microphone here. Please use a current Chrome or Firefox.',
  'call.microphoneError':
    'The microphone could not be opened. Please reload the page.',
};
